// @ts-nocheck
import React, {useState, PropsWithChildren, useEffect} from "react"
import TimeAgo from 'react-timeago'
import {Emit_main} from "../navigation"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faFacebook, faLinkedin, faTiktok, faSquareInstagram} from "@fortawesome/free-brands-svg-icons"
import {faPencil, faTrash, faClock, faEye, faArrowRightArrowLeft, faStar, faSquarePollVertical, faDollarSign, faWaveSquare, faHourglassEnd, faFileInvoiceDollar, faDivide, faPlus, faArrowsRotate, faTableColumns, faChartSimple, faCircleInfo, faXmark } from "@fortawesome/free-solid-svg-icons"
import * as C from "../controls"
import * as P from "../program-state"
import { creative_schema_t, overview_stats_schema, overview_stats_t, creative_overview_schema, creative_overview_t, linkedin_ad_instance_schema, linkedin_ad_instance_t, linkedin_preview_schema, linkedin_preview_t, facebook_ad_instance_schema, facebook_ad_instance_t, facebook_preview_schema, facebook_preview_t, tiktok_ad_instance_schema, creative_stats_schema_t, tiktok_ad_instance_t} from "../resource/types"
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Preview_file_component, preview_data_t, General_card_preview_component } from "./campaigns/common"
import {z} from "zod"
import { Switch } from "./components/switch"


interface StatCardProps {
    data_source: object;
    data_key: string;
    filter?: string;
}


export const addComma = (number : string) => {
    if (number == null) {
      return ""
    }
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


export const format_date_value = (date_string : string) => {
    try {
        const date = new Date(date_string);
        const formatted_date = new Intl.DateTimeFormat(
            'en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' }
        ).format(date);
        return formatted_date;
    } catch (e) {
        return "N/A";
    }
}


const Stats_card : React.FC<PropsWithChildren<StatCardProps>> = ({ data_source, data_key, filter = "all", children }) => {
    const float_values = ["frequency"];
    const money_values = ["cost_per_result", "amount_spend", "daily_budget", "total_budget"]

    const getDataForDisplay = (key : string, _filter : string) => {
        let result : any = data_source?.[key];
        if (result === undefined || result === null) {
            result = "-";
        }

        if (data_key === "end_date") {
            if (result === null) {
                return "♾️";
            } else {
                return format_date_value(result);
            }
        }

        const floatValue = parseFloat(result);

        if (!isNaN(floatValue)) {
            if (data_key === "result") {
                // Round to whole number for result
                return addComma(Math.round(floatValue).toString());
            } else if (money_values.includes(data_key)) {
                // Keep two decimals for money values
                return addComma(floatValue.toFixed(2));
            } else if (float_values.includes(data_key)) {
                // Keep one decimal for float values
                return addComma(floatValue.toFixed(1));
            }
        }

        return addComma(result);
    }

    return (
        <div className="tw-w-full md:tw-w-1/2 lg:tw-w-1/3 tw-p-1">
            <div className="tw-rounded-lg tw-shadow-lg tw-p-2 tw-border">
                <h2 className="tw-text-center tw-text-xl tw-font-semibold tw-text-big-stone-900 tw-overflow-x-hidden">{getDataForDisplay(data_key, filter)}</h2>
                <div className="tw-flex">
                    <div className="tw-w-fit tw-mx-auto tw-truncate tw-text-xs">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}


const Stats_summary_card = ({data_source} : { data_source : any }) => {
    if (!data_source) {
        return (
            <div className="tw-flex tw-flex-wrap tw-justify-center tw-items-center tw-p-6">
                <p className="tw-text-gray-500">No statistics available</p>
            </div>
        )
    }

    return (
        <div className="tw-flex tw-flex-wrap">
            <Stats_card data_source={data_source} data_key="impression">
                <FontAwesomeIcon className="tw-mr-1" size="xs" icon={faEye} fixedWidth/>
                Impression
            </Stats_card>
            <Stats_card data_source={data_source} data_key="reach">
                <FontAwesomeIcon className="tw-mr-1" size="xs" icon={faArrowRightArrowLeft} fixedWidth/>
                Reach
            </Stats_card>
            <Stats_card data_source={data_source} data_key="relevant_score">
                <FontAwesomeIcon className="tw-mr-1" size="xs" icon={faStar} fixedWidth/>
                Relevance Score
            </Stats_card>
            <Stats_card data_source={data_source} data_key="result">
                <FontAwesomeIcon className="tw-mr-1" size="xs" icon={faSquarePollVertical} fixedWidth/>
                Result
            </Stats_card>
            <Stats_card data_source={data_source} data_key="cost_per_result">
                <FontAwesomeIcon className="tw-mr-1" size="xs" icon={faDivide} fixedWidth/>
                Cost per Result
            </Stats_card>
            <Stats_card data_source={data_source} data_key="amount_spend">
                <FontAwesomeIcon className="tw-mr-1" size="xs" icon={faDollarSign} fixedWidth/>
                Amount Spent
            </Stats_card>
            <Stats_card data_source={data_source} data_key="frequency">
                <FontAwesomeIcon className="tw-mr-1" size="xs" icon={faWaveSquare} fixedWidth/>
                Frequency
            </Stats_card>
            <Stats_card data_source={data_source} data_key="end_date">
                <FontAwesomeIcon className="tw-mr-1" size="xs" icon={faHourglassEnd} fixedWidth/>
                End Date
            </Stats_card>
            {data_source.daily_budget !== undefined && (
                <Stats_card data_source={data_source} data_key="daily_budget">
                    <FontAwesomeIcon className="tw-mr-1" size="xs" icon={faFileInvoiceDollar} fixedWidth/>
                    Daily Budget
                </Stats_card>
            )}
            {data_source.total_budget !== undefined && (
                <Stats_card data_source={data_source} data_key="total_budget">
                    <FontAwesomeIcon className="tw-mr-1" size="xs" icon={faFileInvoiceDollar} fixedWidth/>
                    Total Budget
                </Stats_card>
            )}
        </div>
    )
}

const Pagination = () => {
    return (
        <ul className="tw-flex tw-items-center tw--space-x-px tw-h-8 tw-text-sm">
            <li>
                <a href="#" className="tw-flex tw-items-center tw-justify-center tw-px-3 tw-h-8 tw-ms-0 tw-leading-tight tw-text-gray-500 tw-bg-white tw-border tw-border-e-0 tw-border-gray-300 tw-rounded-s-lg tw-hover:bg-gray-100 tw-hover:text-gray-700">
                    <span className="sr-only">Previous</span>
                    <svg className="tw-w-2.5 tw-h-2.5 tw-rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 1 1 5l4 4"/>
                    </svg>
                </a>
            </li>
            <li>
                <a href="#" className="tw-flex tw-items-center tw-justify-center tw-px-3 tw-h-8 tw-leading-tight tw-text-gray-500 tw-bg-white tw-border tw-border-gray-300 tw-hover:bg-gray-100 tw-hover:text-gray-700">1</a>
            </li>
            <li>
                <a href="#" className="tw-flex tw-items-center tw-justify-center tw-px-3 tw-h-8 tw-leading-tight tw-text-gray-500 tw-bg-white tw-border tw-border-gray-300 tw-hover:bg-gray-100 tw-hover:text-gray-700">2</a>
            </li>
            <li>
                <a href="#" aria-current="page" className="tw-z-10 tw-flex tw-items-center tw-justify-center tw-px-3 tw-h-8 tw-leading-tight tw-text-blue-600 tw-border tw-border-blue-300 tw-bg-blue-50 tw-hover:bg-blue-100 tw-hover:text-blue-700">3</a>
            </li>
            <li>
                <a href="#" className="tw-flex tw-items-center tw-justify-center tw-px-3 tw-h-8 tw-leading-tight tw-text-gray-500 tw-bg-white tw-border tw-border-gray-300 tw-hover:bg-gray-100 tw-hover:text-gray-700">4</a>
            </li>
            <li>
                <a href="#" className="tw-flex tw-items-center tw-justify-center tw-px-3 tw-h-8 tw-leading-tight tw-text-gray-500 tw-bg-white tw-border tw-border-gray-300 tw-hover:bg-gray-100 tw-hover:text-gray-700">5</a>
            </li>
            <li>
                <a href="#" className="tw-flex tw-items-center tw-justify-center tw-px-3 tw-h-8 tw-leading-tight tw-text-gray-500 tw-bg-white tw-border tw-border-gray-300 tw-rounded-e-lg tw-hover:bg-gray-100 tw-hover:text-gray-700">
                    <span className="sr-only">Next</span>
                    <svg className="tw-w-2.5 tw-h-2.5 tw-rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4"/>
                    </svg>
                </a>
            </li>
        </ul>
    )
}

const Generic_stats_display_card = ({stats} : {stats : creative_stats_schema_t}) => {
    return (
        <div className="tw-rounded-lg tw-bg-white tw-p-2 tw-mt-2">
            <Stats_summary_card data_source={stats} />
        </div>
    )
}

const Overview_stats_card = () => {
    const [is_loading, set_is_loading] = React.useState(false);
    const [overview_stats, ps, cs] = P.use_overview_stats()

    P.run_once_on_component_creation(() => {
        void P.poll_overview_stats(ps, cs)
    })

    const send_refresh_status_and_stats = async () => {
        const [ok, resp] = await P.issue_formdata_post(P.v1api`smart-campaign/sync-status-stat/campaigns/`, {}, z.any(), cs.token)
        if (!ok) {
            console.log("Error in synching all campaigns data", resp)
            return
        }
        return resp
    }

    const refresh_clicked = async () => {
        set_is_loading(true)
        await send_refresh_status_and_stats()
        await P.poll_overview_stats(ps, cs)
        set_is_loading(false)
    }

    if (!overview_stats) {
        return (
            <div className="tw-bg-gray-200 tw-p-2 tw-rounded-lg">
                <C.Eres_headerxl>Stats Overview</C.Eres_headerxl>
                <div className="tw-rounded-lg tw-bg-white tw-p-6 tw-mt-2">
                    <C.Eres_spin_placeholder className="tw-p-6"/>
                    <p className="tw-text-center tw-mt-2">Loading stats...</p>
                </div>
            </div>
        )
    }

    return (
        <div className="tw-bg-gray-200 tw-p-2 tw-rounded-lg">
            <C.Eres_headerxl>Stats Overview</C.Eres_headerxl>
            <div className="tw-flex tw-flex-col">
                <div className="tw-mt-2 tw-flex tw-items-center">
                    <h2>Networks:</h2>
                    <select className={`tw-ml-2 ${C.form_element_styles}`} defaultValue="all" style={{ width: 120 }} onChange={() => {}}>
                        <option value="all">All</option>
                        <option value="fb">Facebook</option>
                        <option value="li">Linkedin</option>
                        <option value="tt">Tiktok</option>
                    </select>
                    <C.Eres_iconbutton id="f-refresh" icon={is_loading ? "eres-spinner" : faArrowsRotate} type="reset" className="tw-ml-2" onClick={refresh_clicked} disabled={is_loading}>
                        Refresh
                    </C.Eres_iconbutton>
                </div>

                <div className="tw-rounded-lg tw-bg-white tw-p-2 tw-mt-2">
                    <Stats_summary_card data_source={overview_stats} />
                </div>
            </div>
        </div>
    )
}


const Campaign_card = ({creative, selected} : {creative : creative_schema_t, selected ?: boolean}) => {
    const navigate = useNavigate();
    const [ps, cs] = P.use_authenticated_program_state()
    const [is_delete_modal_open, set_is_delete_modal_open] = React.useState<bool>(false)

    const availableNetworkRender = () => {
        const networks = creative.smart_campaign?.networks;

        const raw_facebook = creative.facebook_config != null;
        const facebook = raw_facebook && networks.includes("facebook");
        const instagram = raw_facebook && networks.includes("instagram");
        const linkedin = creative.linkedin_config != null;
        const tiktok = creative.tiktok_config != null;

        if (facebook === false && instagram === false && linkedin === false && tiktok === false) {
            return (<p>This campaign has no social media accounts and is not active.</p>);
        }

        return (
            <>
                {facebook && <span><FontAwesomeIcon icon={faFacebook} aria-hidden="true" className="tw-pe-1"/></span>}
                {instagram && <span><FontAwesomeIcon icon={faSquareInstagram} aria-hidden="true" className="tw-pe-1"/></span>}
                {linkedin && <span><FontAwesomeIcon icon={faLinkedin} aria-hidden="true" className="tw-pe-1"/></span>}
                {tiktok && <span><FontAwesomeIcon icon={faTiktok} aria-hidden="true" className="tw-pe-1"/></span>}
            </>
        )
    }

    const selected_class = selected ? "tw-bg-blue-100" : "";

    const creative_card_clicked = () => {
        navigate(`/campaigns?creative=${creative.id}`);
    }

    const delete_the_item = async () => {
        const [ok, resp] = await P.issue_json_delete(P.v1api`smart-campaign/${creative.smart_campaign.id}/creatives/${creative.id}`, z.any(), cs.token)
        if (ok) {
            set_is_delete_modal_open(false)
            // force immediate refresh of creatives list
            const writableCs = cs as any
            writableCs.creatives = undefined
            writableCs.creatives_last_update = 0
            await P.poll_creatives(ps, writableCs)
            navigate("/campaigns")
        } else {
            console.log("Delete smart creative audience failed", resp)
        }
    }

    const delete_modal_button_strip = (
        <div className="tw-flex tw-gap-1.5 tw-items-center tw-flex-row-reverse">
            <C.Eres_iconbutton tabIndex={2} icon={faTrash} onClick={delete_the_item} className="tw-bg-danger-bg hover:tw-bg-danger-hoverbg">Delete</C.Eres_iconbutton>
            <C.Eres_iconbutton tabIndex={1} icon={faXmark} onClick={() => set_is_delete_modal_open(false)}>Cancel</C.Eres_iconbutton>
        </div>
    )

    return (
        <C.Eres_card onClick={creative_card_clicked}>
            { is_delete_modal_open &&
                <C.Eres_modal button_strip={delete_modal_button_strip} title={`Are you sure you want to delete this smart campaign ${creative.name}?`} >
                    <p>This currently cannot be undone. Are you sure you want to delete {creative.name}.</p>
                </C.Eres_modal>
            }
            <div className={`tw-cursor-pointer hover:tw-bg-gray-300 ${selected_class}`}>
                <Preview_file_component file_id={creative?.file_id} />
                <div className="tw-p-3">
                    {/* content */}
                    <C.Eres_headerlg>{creative?.name}</C.Eres_headerlg>
                    <h3 className="tw-text-big-stone-950 tw-text-sm tw-text-red-600">{creative.headline}</h3>
                    <div className="tw-p-2">
                        <C.Eres_hline />
                    </div>

                    <div className="tw-flex tw-justify-between tw-items-center">
                        <p className="tw-text-sm">Available on:</p>
                        <div>
                            {availableNetworkRender()}
                        </div>
                    </div>

                    <div className="tw-p-2">
                        <C.Eres_hline />
                    </div>
                    <div className="tw-flex tw-justify-between">
                        <div>
                            <FontAwesomeIcon className="tw-mr-1" icon={faClock} size="xs" />
                            <TimeAgo date={creative._created} className="tw-text-sm"></TimeAgo>
                        </div>
                        <div>
                            <a href={`/campaigns/edit/${creative.id}`} onClick={() => {}}><FontAwesomeIcon icon={faPencil} aria-hidden="true" className="tw-mr-1"/></a>
                            <a href="#" onClick={() => {set_is_delete_modal_open(true)}}><FontAwesomeIcon icon={faTrash} aria-hidden="true"/></a>
                        </div>
                    </div>
                </div>
            </div>
        </C.Eres_card>
    )
}


const Facebook_detail_preview = ({creative, facebook_ad_instance} : {creative: creative_schema_t, facebook_ad_instance : facebook_ad_instance_t}) => {
    const [_, cs] = P.use_authenticated_program_state()
    const [preview_params, set_preview_params] = useState<facebook_preview_t | null>(null)
    const get_preview = async () => {
        const fb_generic = "fb_generic";
        const ig_generic = "ig_generic";
        const [ok, resp] = await P.issue_json_post(
            P.v1api`social/facebook/generate_ad_preview/${creative.facebook_config.instance_ad_id}?kind=${fb_generic}`,
            {}, facebook_preview_schema, cs.token
        )
        if (!ok) {
            console.log("Error in calling get linkedin ad preview", resp)
            return
        }
        set_preview_params(resp);
    }

    useEffect(()=> {
        get_preview()
    }, [creative.facebook_config.instance_ad_id])

    return (
        <div className="bg-white rounded-lg p-2">
          {
            preview_params != null ?
              <iframe className="tw-w-full" {...preview_params}></iframe> :
              <div className="tw-flex tw-flex-col">
                <C.Eres_spin_placeholder className="tw-p-6"/>
                <p className="tw-text-center">Fetching facebook preview</p>
              </div>
          }
        </div>
    )
}


const Linkedin_detail_preview = ({creative} : {creative : creative_schema_t}) => {
    if (!creative) {
        return null
    }

    const [_, cs] = P.use_authenticated_program_state()
    const [preview_params, set_preview_params] = useState<linkedin_preview_t | null>(null)

    const get_preview = async () => {
        const [ok, resp] = await P.issue_json_post(
            P.v1api`social/linkedin/generate_ad_preview/${creative.linkedin_config.instance_ad_id}`,
            {}, linkedin_preview_schema, cs.token
        )
        if (!ok) {
            console.log("Error in calling get linkedin ad preview", resp)
            return
        }

        if (resp?.width) delete resp.width;
        set_preview_params(resp);
    }

    useEffect(()=> {
        get_preview()
    }, [creative])

    return (
        <div className="bg-white rounded-lg p-2">
          {
            preview_params != null ?
              <iframe className="tw-w-full" {...preview_params}></iframe> :
              <div className="tw-flex tw-flex-col">
                <C.Eres_spin_placeholder className="tw-w-4 tw-h-4 tw-p-6"/>
                <p className="tw-text-center">Fetching linkedin preview</p>
              </div>
          }
        </div>
    )
}


const Tiktok_detail_preview = ({creative} : {creative : creative_schema_t}) => {
    const creative_to_preview_data : preview_data_t = (creative : creative_schema_t) => {
        return {
            headline: creative.headline,
            message: creative.message,
            link: creative.link,
            file_id: creative.file_id,
            tiktok_budget: creative.smart_campaign?.tiktok_budget,
            tiktok_bid_amount: creative.smart_campaign?.tiktok_bid_amount
        }
    }

    const preview_data = creative_to_preview_data(creative)

    return (
        <div className="bg-white rounded-lg p-2">
            <General_card_preview_component network="tiktok" preview_data={preview_data} />
        </div>
    )
}


// @TODO: better naming
const Individual_stats_overview_card = ({creative} : {creative : creative_schema_t}) => {
    const [is_loading, set_is_loading] = React.useState(false);
    const [overview_stats, ps, cs] = P.use_overview_stats()

    P.run_once_on_component_creation(() => {
        void P.poll_overview_stats(ps, cs)
    })

    return (
        <div className="tw-bg-gray-200 tw-p-2 tw-rounded-lg">
            <C.Eres_headerxl>Stats Overview</C.Eres_headerxl>
            <div className="tw-flex tw-flex-col">
                <div className="tw-mt-2 tw-flex tw-items-center">
                    <h2>Networks:</h2>
                    <select className={`tw-ml-2 ${C.form_element_styles}`} defaultValue="all" style={{ width: 120 }} onChange={() => {}}>
                        <option value="all">All</option>
                    </select>
                    <C.Eres_iconbutton id="f-refresh" icon={is_loading ? "eres-spinner" : faArrowsRotate} type="reset" className="tw-ml-2" disabled={is_loading}>
                        Refresh
                    </C.Eres_iconbutton>
                </div>

                <div className="tw-rounded-lg tw-bg-white tw-p-2 tw-mt-2">
                    <Stats_summary_card data_source={overview_stats} />
                </div>
            </div>
        </div>
    )
}

const Individual_facebook_overview = ({creative, creative_overview} : {creative : creative_schema_t, creative_overview ?: creative_overview_t}) => {    
    const { facebook_config } = creative;

    if (!facebook_config) {
        return (
            <div className="tw-bg-gray-200 tw-rounded-lg tw-mt-2">
                <C.Eres_bare_card>
                    <h2 className="font-semibold">You have not activated an advertisement on Linkedin yet</h2>
                </C.Eres_bare_card>
            </div>
        )
    }

    if (["TASK_SENT", "TASK_PENDING"].includes(facebook_config.instance_ad_status)) {
        return (
            <div className="tw-bg-gray-200 tw-rounded-lg tw-mt-2">
                <C.Eres_bare_card>
                    <h2 className="font-semibold">The advertisement on this network is being created in the background, please wait a moment for it to appear</h2>
                    <p>You can refresh to get the latest content</p>
                </C.Eres_bare_card>
            </div>
        )
    }

    const [_, cs] = P.use_authenticated_program_state()
    const [is_loading, set_is_loading] = React.useState<boolean>(false);
    const [is_toggle_loading, set_is_toggle_loading] = React.useState<boolean>(false);
    const [is_toggle_checked, set_is_toggle_checked] = React.useState<boolean>(false);
    const [facebook_ad_instance, set_facebook_ad_instance] = React.useState<facebook_ad_instance_t | null>(null)

    const send_retry_create_facebook_ad = async () => {
        const [ok, resp] = await P.issue_formdata_post(
            P.v1api`smart-campaign/campaigns/retry/facebook/${creative.id}/${facebook_config.id}`,
            {}, 
            z.any(),
            cs.token
        )

        if (!ok) {
            console.log("Error in calling retry on failed facebook ad instance", resp)
            return
        }
        return resp
    }

    const retry_clicked = async () => {
        set_is_loading(true)
        await send_retry_create_facebook_ad()
        set_is_loading(false)
    }

    if (facebook_config.instance_ad_status == "TASK_ERROR") {
        return (
            <div className="tw-bg-gray-200 tw-rounded-lg tw-mt-2">
                <C.Eres_bare_card>
                    <h2 className="font-semibold">There was error creating the advertisement on this network</h2>
                    <C.Eres_warning_badge>{facebook_config.instance_ad_message?.title}</C.Eres_warning_badge>
                    <br />
                    <C.Eres_card>
                        <div className="tw-flex tw-overflow-x-auto tw-ml-2 tw-p-2 tw-items-center">
                        {facebook_config.instance_ad_message?.message}
                        </div>
                    </C.Eres_card>
                    <C.Eres_iconbutton id="f-retry" icon={is_loading ? "eres-spinner" : faArrowsRotate} type="reset" className="tw-w-full tw-my-2" onClick={retry_clicked} disabled={is_loading}>
                        Retry
                    </C.Eres_iconbutton>
                </C.Eres_bare_card>
            </div>
        )
    }

    const is_ad_toggle_checked = (facebook_ad_instance : facebook_ad_instance_t) => {
        let system_status = facebook_ad_instance?.ad && facebook_ad_instance.ad.meta__system_status;
        let status = facebook_ad_instance?.campaign && facebook_ad_instance.campaign.effective_status;

        if (system_status != null && system_status == "ON") {
            return true;
        }

        // case when system status is null
        if (["ACTIVE", "PENDING_REVIEW", "IN_PROCESS"].includes(status)) {
            return true;
        }
        else {
            return false;
        }
    }

    useEffect(() => {
        const facebook_ad_instance : facebook_ad_instance_t = get_facebook_ad_instance()
        set_is_toggle_checked(is_ad_toggle_checked(facebook_ad_instance))
    }, [creative])

    const get_facebook_ad_instance = async () => {
        const [ok, resp] = await P.issue_json_get(
            P.v1api`smart-campaign/campaigns/${creative.smart_campaign.id}/facebook/${creative.facebook_config.instance_ad_id}`,
            facebook_ad_instance_schema,
            cs.token
        )

        if (!ok) {
            console.log("Error in calling get facebook ad instance", resp)
            return
        }

        console.log('.i. get_facebook_ad_instance: ', resp)
        set_facebook_ad_instance(resp)
        return resp
    }

    const tabs: C.TabItem[] = [
        { id: 1, icon: faChartSimple, label: "Stats", content: <Generic_stats_display_card stats={creative_overview?.statistics.facebook} /> },
        { id: 2, icon: faCircleInfo, label: "Detail", content: <Facebook_detail_preview creative={creative} facebook_ad_instance={facebook_ad_instance} /> },
    ];

    const control_ad_status = async (checked) => {
        set_is_toggle_loading(true)
        const status = checked ? "ACTIVE" : "PAUSED"
        const [ok, resp] = await P.issue_json_post(
            P.v1api`smart-campaign/campaigns/${creative.smart_campaign.id}/facebook/${creative.facebook_config.instance_ad_id}`,
            {status},
            z.any(),
            cs.token
        )
        if (!ok) {
            console.log("Error in calling update facebook ad status", resp)
        }
        set_is_toggle_checked(checked)
        set_is_toggle_loading(false)
    }

    return (
        <div className="tw-bg-gray-200 tw-rounded-lg tw-mt-2">
            <C.Eres_bare_card>
                <div className="tw-flex tw-mt-2 tw-p-2 tw-items-center tw-space-x-2 tw-bg-white tw-rounded">
                    { is_toggle_loading && <div className="tw-w-6"><C.Eres_spin_placeholder /></div>}
                    <Switch checked={is_toggle_checked} disabled={is_toggle_loading} onCheckedChange={control_ad_status} />
                    <h2>Status: <C.Eres_info_badge>{facebook_ad_instance?.campaign.effective_status}</C.Eres_info_badge></h2>
                </div>
                {
                facebook_ad_instance?.ad.ad_review_feedback && 
                    <div className="tw-flex tw-mt-2 tw-p-2 tw-items-center tw-space-x-2">
                        <pre>{facebook_ad_instance?.ad.ad_review_feedback}</pre>
                    </div>
                }
                <div className="tw-mt-2"></div>
                <C.Eres_tab defaultTab={1} tabs={tabs} />
                
            </C.Eres_bare_card>
        </div>
    )
}


const Individual_tiktok_overview = ({creative, creative_overview} : {creative : creative_schema_t, creative_overview ?: creative_overview_t}) => {    
    const { tiktok_config } = creative;

    if (!tiktok_config) {
        return (
            <div className="tw-bg-gray-200 tw-rounded-lg tw-mt-2">
                <C.Eres_bare_card>
                    <h2 className="font-semibold">You have not activated an advertisement on Tiktok yet</h2>
                </C.Eres_bare_card>
            </div>
        )
    }

    if (["TASK_SENT", "TASK_PENDING"].includes(tiktok_config.instance_ad_status)) {
        return (
            <div className="tw-bg-gray-200 tw-rounded-lg tw-mt-2">
                <C.Eres_bare_card>
                    <h2 className="font-semibold">The advertisement on this network is being created in the background, please wait a moment for it to appear</h2>
                    <p>You can refresh to get the latest content</p>
                </C.Eres_bare_card>
            </div>
        )
    }

    const [_, cs] = P.use_authenticated_program_state()
    const [is_loading, set_is_loading] = React.useState(false);
    const [tiktok_ad_instance, set_tiktok_ad_instance] = React.useState<tiktok_ad_instance_t | null>(null)
    const [is_toggle_loading, set_is_toggle_loading] = React.useState<boolean>(false);
    const [is_toggle_checked, set_is_toggle_checked] = React.useState<boolean>(false);

    const send_retry_create_tiktok_ad = async () => {
        const [ok, resp] = await P.issue_formdata_post(P.v1api`smart-campaign/campaigns/retry/tiktok/${creative.id}/${tiktok_config.id}`, {}, z.any(), cs.token)
        if (!ok) {
            console.log("Error in calling retry on failed tiktok ad instance", resp)
            return
        }
        return resp
    }

    const retry_clicked = async () => {
        set_is_loading(true)
        await send_retry_create_tiktok_ad()
        set_is_loading(false)
    }

    if (tiktok_config.instance_ad_status == "TASK_ERROR") {
        return (
            <div className="tw-bg-gray-200 tw-rounded-lg tw-mt-2">
                <C.Eres_bare_card>
                    <h2 className="font-semibold">There was error creating the advertisement on this network</h2>
                    <C.Eres_warning_badge>{tiktok_config.instance_ad_message?.title}</C.Eres_warning_badge>
                    <br />
                    <C.Eres_card>
                        <div className="tw-flex tw-overflow-x-auto tw-ml-2 tw-p-2 tw-items-center">
                        {tiktok_config.instance_ad_message?.message}
                        </div>
                    </C.Eres_card>
                    <C.Eres_iconbutton id="f-retry" icon={is_loading ? "eres-spinner" : faArrowsRotate} type="reset" className="tw-w-full tw-my-2" onClick={retry_clicked} disabled={is_loading}>
                        Retry
                    </C.Eres_iconbutton>
                </C.Eres_bare_card>
            </div>
        )
    }

    const get_tiktok_ad_instance = async () => {
        const [ok, resp] = await P.issue_json_get(
            P.v1api`smart-campaign/campaigns/${creative.smart_campaign.id}/tiktok/${creative.tiktok_config.instance_ad_id}`,
            tiktok_ad_instance_schema,
            cs.token
        )

        if (!ok) {
            console.log("Error in calling get facebook ad instance", resp)
            return
        }

        set_tiktok_ad_instance(resp)
        return resp
    }

    const is_ad_toggle_checked = (tiktok_ad_instance : tiktok_ad_instance_t) => {
        let system_status = tiktok_ad_instance?.ad && tiktok_ad_instance.ad.meta__system_status;
        let status = tiktok_ad_instance?.campaign && tiktok_ad_instance.campaign.operation_status;

        if (system_status != null && system_status == "ON") {
            return true;
        }

        // case when system status is null
        if (status == "ENABLE") {
            return true;
        }
        else {
            return false;
        }
    }

    useEffect(() => {
        const tt_ad_instance : tiktok_ad_instance_t = get_tiktok_ad_instance()
        set_is_toggle_checked(is_ad_toggle_checked(tt_ad_instance))
    }, [creative])

    const control_ad_status = async (checked) => {
        set_is_toggle_loading(true)
        const status = checked ? "ENABLE" : "DISABLE"
        const [ok, resp] = await P.issue_json_post(
            P.v1api`smart-campaign/campaigns/${creative.smart_campaign.id}/tiktok/${creative.tiktok_config.instance_ad_id}`,
            {status},
            z.any(),
            cs.token
        )
        if (!ok) {
            console.log("Error in calling update tiktok ad status", resp)
        }
        set_is_toggle_checked(checked)
        set_is_toggle_loading(false)
    }

    const tabs: C.TabItem[] = [
        { id: 1, icon: faChartSimple, label: "Stats", content: <Generic_stats_display_card stats={creative_overview?.statistics.tiktok} /> },
        { id: 2, icon: faCircleInfo, label: "Detail", content: <Tiktok_detail_preview creative={creative} tiktok_ad_instance={tiktok_ad_instance} /> },
    ];

    return (
        <div className="tw-bg-gray-200 tw-rounded-lg tw-mt-2">
            <C.Eres_bare_card>
                <div className="tw-flex tw-mt-2 tw-p-2 tw-items-center tw-space-x-2 tw-bg-white">
                    { is_toggle_loading && <div className="tw-w-6"><C.Eres_spin_placeholder /></div>}
                    <Switch checked={is_toggle_checked} disabled={is_toggle_loading} onCheckedChange={control_ad_status} />
                    <h2>Status: <C.Eres_info_badge>{tiktok_ad_instance?.campaign.operation_status}</C.Eres_info_badge></h2>
                </div>
                <C.Eres_tab defaultTab={1} tabs={tabs} />
            </C.Eres_bare_card>
        </div>
    )
}


const Individual_linkedin_overview = ({creative, creative_overview} : {creative : creative_schema_t, creative_overview ?: creative_overview_t}) => {
    const { linkedin_config } = creative;

    if (!linkedin_config) {
        return (
            <div className="tw-bg-gray-200 tw-rounded-lg tw-mt-2">
                <C.Eres_bare_card>
                    <h2 className="font-semibold">You have not activated an advertisement on Linkedin yet</h2>
                </C.Eres_bare_card>
            </div>
        )
    }

    if (["TASK_SENT", "TASK_PENDING"].includes(linkedin_config.instance_ad_status)) {
        return (
            <div className="tw-bg-gray-200 tw-rounded-lg tw-mt-2">
                <C.Eres_bare_card>
                    <h2 className="font-semibold">The advertisement on this network is being created in the background, please wait a moment for it to appear</h2>
                    <p>You can refresh to get the latest content</p>
                </C.Eres_bare_card>
            </div>
        )
    }

    const [_, cs] = P.use_authenticated_program_state()
    const [is_loading, set_is_loading] = React.useState(false);
    const send_retry_create_linkedin_ad = async () => {
        const [ok, resp] = await P.issue_formdata_post(P.v1api`smart-campaign/campaigns/retry/linkedin/${creative.id}/${linkedin_config.id}`, {}, z.any(), cs.token)
        if (!ok) {
            console.log("Error in calling retry on failed linkedin ad instance", resp)
            return
        }
        return resp
    }
    const retry_clicked = async () => {
        set_is_loading(true)
        await send_retry_create_linkedin_ad()
        set_is_loading(false)
    }

    if (linkedin_config.instance_ad_status == "TASK_ERROR") {
        return (
            <div className="tw-bg-gray-200 tw-rounded-lg tw-mt-2">
                <C.Eres_bare_card>
                    <h2 className="font-semibold">There was error creating the advertisement on this network</h2>
                    <C.Eres_warning_badge>{linkedin_config.instance_ad_message?.title}</C.Eres_warning_badge>
                    <br />
                    <C.Eres_card>
                        <div className="tw-flex tw-overflow-x-auto tw-ml-2 tw-p-2 tw-items-center">
                        {linkedin_config.instance_ad_message?.message}
                        </div>
                    </C.Eres_card>
                    <C.Eres_iconbutton id="f-retry" icon={is_loading ? "eres-spinner" : faArrowsRotate} type="reset" className="tw-w-full tw-my-2" onClick={retry_clicked} disabled={is_loading}>
                        Retry
                    </C.Eres_iconbutton>
                </C.Eres_bare_card>
            </div>
        )
    }

    const [linkedin_ad_instance, set_linkedin_ad_instance] = useState<linkedin_ad_instance_t | null>(null)
    const [is_toggle_loading, set_is_toggle_loading] = React.useState<boolean>(false);
    const [is_toggle_checked, set_is_toggle_checked] = React.useState<boolean>(false);

    const get_linkedin_ad_instance = async () => {
        const [ok, resp] = await P.issue_json_get(
            P.v1api`smart-campaign/campaigns/${creative.smart_campaign.id}/linkedin/${creative.linkedin_config.instance_ad_id}`,
            linkedin_ad_instance_schema,
            cs.token
        )

        if (!ok) {
            console.log("Error in calling get linkedin ad instance", resp)
            return
        }
        console.log('.i. get_linkedin_ad_instance: ', resp)
        set_linkedin_ad_instance(resp)
        return resp
    }

    const is_ad_toggle_checked = (linkedin_ad_instance : linkedin_ad_instance_t) => {
        let system_status = linkedin_ad_instance?.creative && linkedin_ad_instance.creative.meta__system_status;
        let status = linkedin_ad_instance?.campaign_group && linkedin_ad_instance.campaign_group.status;

        if (system_status != null && system_status == "ACTIVE") {
            return true;
        }

        // case when system status is null
        if (["ACTIVE", "PENDING_REVIEW", "IN_PROCESS"].includes(status)) {
            return true;
        }
        else {
            return false;
        }
    }

    const control_ad_status = async (checked) => {
        set_is_toggle_loading(true)
        const status = checked ? "ACTIVE" : "PAUSED"
        const [ok, resp] = await P.issue_json_post(
            P.v1api`smart-campaign/campaigns/${creative.smart_campaign.id}/linkedin/${creative.linkedin_config.instance_ad_id}`,
            {status},
            z.any(),
            cs.token
        )
        if (!ok) {
            console.log("Error in calling update linkedin ad status", resp)
        }
        set_is_toggle_checked(checked)
        set_is_toggle_loading(false)
    }

    useEffect(() => {
        const linkedin_ad_instance : linkedin_ad_instance_t = get_linkedin_ad_instance()
        set_is_toggle_checked(is_ad_toggle_checked(linkedin_ad_instance))
    }, [creative])

    const tabs: C.TabItem[] = [
        { id: 1, icon: faChartSimple, label: "Stats", content: <Generic_stats_display_card stats={creative_overview?.statistics.linkedin} /> },
        { id: 2, icon: faCircleInfo, label: "Detail", content: <Linkedin_detail_preview creative={creative} /> },
    ];

    return (
        <div className="tw-bg-gray-200 tw-rounded-lg tw-mt-2">
            <C.Eres_bare_card>
                <div className="tw-flex tw-mt-2 tw-p-2 tw-items-center tw-space-x-2 tw-bg-white">
                    { is_toggle_loading && <div className="tw-w-6"><C.Eres_spin_placeholder /></div>}
                    <Switch checked={is_toggle_checked} disabled={is_toggle_loading} onCheckedChange={control_ad_status} />
                    <h2>Status: <C.Eres_info_badge>{linkedin_ad_instance?.campaign_group.status}</C.Eres_info_badge></h2>
                </div>
                { linkedin_ad_instance?.creative?.meta__system_message && <p>{linkedin_ad_instance.creative?.meta__system_message}</p> }
                <C.Eres_tab defaultTab={1} tabs={tabs} />
            </C.Eres_bare_card>
        </div>
    )
}

const Individual_creative_overview = ({creative} : {creative : creative_schema_t}) => {
    const [ps, cs] = P.use_authenticated_program_state()
    const [creative_overview, set_creative_overview] = useState<creative_overview_t | null>(null)

    const get_creative_overview_stats = async () => {
        const [rok, resp] = await P.issue_json_get(P.v1api`insight/overview/${creative.id}`, creative_overview_schema, cs.token)
        if (!rok) {
            console.log("Error in fetching creative overview stats", resp)
            return
        }
        set_creative_overview(resp)
    }

    useEffect(() => {
        get_creative_overview_stats()
    }, [creative])

    // @TODO: badge color and StatisticsDisplay
    return (
        <div className="tw-bg-gray-200 tw-rounded-lg tw-mt-2">
            <C.Eres_bare_card>
                <div className="tw-p-2">
                    <C.Eres_card>
                        <div className="tw-flex tw-overflow-x-auto tw-ml-2 tw-p-2 tw-items-center">
                            <h2 className="tw-text-sm tw-w-content">Availability:</h2>
                            <div className="tw-flex tw-space-x-2 tw-ml-2">
                                {
                                    creative_overview?.status.facebook &&
                                    <div className="tw-rounded tw-border tw-flex tw-items-center tw-space-x-1 tw-text-sm tw-p-1">
                                        <h5>Facebook:</h5>
                                        <C.Eres_info_badge>{creative_overview.status.facebook}</C.Eres_info_badge>
                                    </div>
                                }
                                {
                                    creative_overview?.status.linkedin &&
                                    <div className="tw-rounded tw-border tw-flex tw-items-center tw-space-x-1 tw-text-sm tw-p-1">
                                        <span>Linkedin:</span>
                                        <C.Eres_danger_badge>{creative_overview.status.linkedin}</C.Eres_danger_badge>
                                    </div>
                                }

                                {
                                    creative_overview?.status.tiktok &&
                                    <div className="tw-rounded tw-border tw-flex tw-items-center tw-space-x-1 tw-text-sm tw-p-1">
                                        <span>Tiktok:</span>
                                        <C.Eres_warning_badge>{creative_overview.status.tiktok}</C.Eres_warning_badge>
                                    </div>
                                }
                            </div>
                        </div>
                    </C.Eres_card>
                </div>
            </C.Eres_bare_card>
            <Individual_stats_overview_card creative={creative} />
        </div>
    )
}


const Individual_campaign_overview = ({creatives, creative_id} : {creatives : creative_schema_t[], creative_id ?: number}) => {
    const creative = P.get_creative(creatives, creative_id)

    if (!creative) {
        return <p>Creative not found</p>
    }
    const [_, cs] = P.use_authenticated_program_state()
    const [creative_overview, set_creative_overview] = useState<creative_overview_t | null>(null)
    const get_creative_overview_stats = async () => {
        const [rok, resp] = await P.issue_json_get(P.v1api`insight/overview/${creative.id}`, creative_overview_schema, cs.token)
        if (!rok) {
            console.log("Error in fetching creative overview stats", resp)
            return
        }
        set_creative_overview(resp)
    }

    useEffect(() => {
        get_creative_overview_stats()
    }, [creative])

    const networks = creative.smart_campaign.networks || [];
    const raw_facebook = creative?.facebook_config != null;
    const facebook = raw_facebook && networks.includes("facebook");
    const instagram = raw_facebook && networks.includes("instagram");
    const linkedin = creative?.linkedin_config != null;
    const tiktok = creative?.tiktok_config != null;

    let tab_items : C.TabItem[] = [
        { id: 1, icon: faTableColumns, label: "Overview", content: <Individual_creative_overview creative={creative} /> },
    ]
    // @TODO: instagram
    facebook && tab_items.push( { id: 2, icon: faFacebook, label: "Facebook", content: <Individual_facebook_overview creative={creative} creative_overview={creative_overview} /> })
    linkedin && tab_items.push({ id: 3, icon: faLinkedin, label: "Linkedin", content: <Individual_linkedin_overview creative={creative} creative_overview={creative_overview} /> })
    tiktok && tab_items.push({ id: 4, icon: faTiktok, label: "Tiktok", content: <Individual_tiktok_overview creative={creative} creative_overview={creative_overview} /> })

    const is_not_available_at_all = !facebook && !instagram && !linkedin && !tiktok;


    return is_not_available_at_all ? <div>This campaign has no social media accounts and is not active.</div> : (
        <div>
            <C.Eres_tab defaultTab={1} tabs={tab_items} />
        </div>
    )
}


const Empty_campaigns_state = () => {
    return (
        <div className="tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-12 tw-space-y-6">
            <div className="tw-text-center tw-space-y-3">
                <FontAwesomeIcon icon={faChartSimple} className="tw-text-gray-400 tw-text-6xl" />
                <C.Eres_header2xl className="tw-text-gray-700">No campaigns yet</C.Eres_header2xl>
                <p className="tw-text-gray-600 tw-max-w-md">
                    Get started by creating your first campaign. You can publish ads across multiple networks from a single campaign.
                </p>
            </div>
            <div className="tw-flex tw-flex-col tw-space-y-3 tw-items-center">
                <Link to="/campaigns/create">
                    <C.Eres_iconbutton icon={faPlus} className="tw-text-lg tw-px-6 tw-py-3">
                        Create Your First Campaign
                    </C.Eres_iconbutton>
                </Link>
                <Link to="/wizard" className="tw-text-blue-600 hover:tw-underline tw-text-sm">
                    Or start with the setup wizard
                </Link>
            </div>
        </div>
    )
}

const Onboarding_banner = () => {
    const navigate = useNavigate();
    const [brands] = P.use_brands();
    const [connected_networks] = P.use_connected_networks();

    // wait for data to load before showing banner
    if (brands === undefined || connected_networks === undefined) return null;

    const has_network = connected_networks.length > 0;
    const has_brand = brands.length > 0;
    const needs_onboarding = !has_network || !has_brand;

    if (!needs_onboarding) return null;

    return (
        <C.Eres_card className="tw-mb-4 tw-border-blue-200 tw-bg-blue-50">
            <div className="tw-p-4 tw-flex tw-items-center tw-justify-between">
                <div>
                    <p className="tw-font-semibold tw-text-blue-900">Complete your onboarding to get started</p>
                    <p className="tw-text-sm tw-text-blue-700">
                        {!has_network && !has_brand ? "Connect a social network and create a brand to run campaigns." :
                         !has_network ? "Connect a social network to run campaigns." :
                         "Create a brand to organize your campaigns."}
                    </p>
                </div>
                <C.Eres_button onClick={() => navigate('/onboarding')}>
                    Continue onboarding
                </C.Eres_button>
            </div>
        </C.Eres_card>
    );
};

const Campaign_list_display = () => {
    const location = useLocation();
    const query_params = new URLSearchParams(location.search);
    const creative_id = query_params.get('creative');

    const [selected_creative, set_selected_creative] = useState<string | null>(null);

    P.run_once_on_component_creation(() => {
        void P.poll_creatives(ps, cs)
    })
    const [creatives, ps, cs] = P.use_creatives()

    useEffect(() => {
        set_selected_creative(creative_id)
    }, [creative_id])

    // show empty state if no campaigns exist
    if (creatives !== undefined && creatives.length === 0) {
        return <Empty_campaigns_state />
    }

    return (
        <div className="tw-w-full tw-flex tw-flex-col tw-space-y-4">
            <Onboarding_banner />
            <div className="tw-w-full tw-flex tw-flex-row tw-space-x-2">
            <div className="tw-w-2/4 tw-flex tw-flex-col tw-space-y-4">
                <C.Eres_card>
                    <div className="tw-p-2">
                        <div className="tw-w-full tw-py-2">
                            <div className="tw-flex tw-justify-end tw-items-center">
                                <Link to="/campaigns/create">
                                    <C.Eres_iconbutton icon={faPlus} >Create Campaign</C.Eres_iconbutton>
                                </Link>
                            </div>
                        </div>
                        <C.Eres_card>
                            <div className="tw-p-2 tw-flex tw-flex-col tw-space-y-3">
                                {
                                creatives ?
                                    creatives.map((creative) => <Campaign_card key={creative.id} creative={creative} selected={selected_creative == creative.id} />)
                                    : <C.Eres_spin_placeholder className="tw-p-6"/>
                                }
                            </div>
                            {creatives && creatives.length > 0 && (
                                <div className="tw-flex tw-justify-end tw-p-2">
                                    <Pagination />
                                </div>
                            )}
                        </C.Eres_card>
                    </div>
                </C.Eres_card>
            </div>

            <div className="tw-w-2/4 tw-h-full tw-border tw-p-2 tw-rounded-lg tw-flex tw-flex-col tw-space-y-4 tw-sticky tw-top-0">
                { selected_creative ? <Individual_campaign_overview creatives={creatives} creative_id={selected_creative} /> : <Overview_stats_card /> }
            </div>
            </div>
        </div>
    )
}


const Campaigns = () => {
    return (
        <Emit_main page_id="PAGE-campaigns">
            <Campaign_list_display />
        </Emit_main>
    )
}


export default Campaigns;
